// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","396":"7e2b787e","455":"b03c38fe","857":"2baa0ee2","977":"988e79fa"}[chunkId] + ".chunk.js";
};